module.exports = global["jQuery"] = require("-!C:\\work\\sega\\sega\\node_modules\\source-map-loader\\index.js!C:\\work\\sega\\sega\\node_modules\\source-map-loader\\index.js!C:\\work\\sega\\sega\\node_modules\\jquery\\dist\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/source-map-loader!./~/jquery/dist/jquery.js
// module id = 2
// module chunks = 0